import { render, staticRenderFns } from "./c-indicator@.vue?vue&type=template&id=a5a4b1c0&"
import script from "./c-indicator@.vue?vue&type=script&lang=ts&"
export * from "./c-indicator@.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports